<template>
  <div class='SelectSpinner'>
    <div class="top">
      <div class="label">Biblioteca de Spinners(animação de carregamento):</div>
      <div class="close">
        <close-icon @click="SetModal({ active: false })"/>
      </div>
    </div>
    <div class="cont-icons">
        <div
        v-for="(s, key) in spinners"
        :key="key"
        class="cont-icon-unit"
        >
          <component
          :is="s"
          :size="s === 'EnbSyncLoader' ? '10px' : '40px'"
          color="#000000"
          style="cursor: pointer"
          @click="set(s)"
          />
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseIcon from '../Icons/CloseIcon'
import { loaders, alias } from '@/components/Spinner'
export default {
  name: 'SelectSpinner',
  components: { CloseIcon, ...loaders },
  computed: {
    ...mapGetters(['EnbModal'])
  },
  data () {
    return {
      spinners: alias
    }
  },
  methods: {
    ...mapActions(['SetModal', 'UpdatePrefComp']),
    set (s) {
      this.UpdatePrefComp({ comp: 'spinner', prop: 'tipo', value: s })
        .then(() => {
          this.SetModal({ active: false })
        })
    } 
  }

}
</script>

<style scoped>
.SelectSpinner {
  width: 50%;
  height: 70%;
  position: absolute;
  margin: auto;
  background-color: #FFFFFF;
  border-radius: 5px;
  overflow: hidden;
}

.top {
  display: flex;
  padding: 2%;
  background-color: #CCCCCC;
}

.label {
  width: 95%;
  text-align: left;
}

.close {
  width: 5%;
  text-align: right;
}

.cont-icons {
  display: flex;
  flex-wrap: wrap;
  padding: 2%;
}

.cont-icons div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cont-icon-unit {
  margin: 2%;
}
</style>
